<ion-toolbar *ngIf="chips.length">
  <ion-row class="js-chips-slider">
    <ui-mobile-chip *ngFor="let chip of chips" [chip]="chip" id="AT_chip_{{ chip.label.replace('.', '_') }}" (click)="selectChip(chip)" [hidden]="chip.hide"></ui-mobile-chip>
  </ion-row>
</ion-toolbar>
